// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"ff600b80","113":"4223160d","384":"f233157c","458":"504d2c50","924":"b3a45ce3"}[chunkId] + ".chunk.js";
};